import {inject, Injectable, signal} from "@angular/core";
import {AbstractController} from "../../../controllers/AbstractController";
import {IAlertFeedbackController, MK_ALERT_FEEDBACK} from "./IAlertFeedbackController";
import {AlertFeedbackRepository} from "../../../repositories/alert-feedback.repository";
import {UserSessionRepository} from "../../../repositories/user-session.repository";
import {UserSession} from "../../../interfaces/domain/UserSession";
import {AlertData} from "../../../interfaces/domain/alert/AlertData";
import {AlertFeedback} from "../../../interfaces/rest/AlertFeedback";
import {AlertStatus} from "../../../interfaces/domain/alert/AlertStatus";

@Injectable()
export class AlertFeedbackController extends AbstractController implements IAlertFeedbackController {

  private readonly alertFeedbackRepository: AlertFeedbackRepository;
  private readonly userSessionRepository: UserSessionRepository;
  private readonly userSession: UserSession;

  constructor() {
    super();

    this.alertFeedbackRepository = inject(AlertFeedbackRepository);
    this.userSessionRepository = inject(UserSessionRepository);


    this.addModel(MK_ALERT_FEEDBACK, {
      currentFeedback$: signal(null),
      alertData$: signal(null),
    });

    this.userSession  = this.userSessionRepository.getUserSession()!;
  }

  handleSelectFeedback(feedback: 'POSITIVE'|'NEGATIVE') {
    let model = this.getModel(MK_ALERT_FEEDBACK);
    if(model.alertData$()!.currentFeedback === feedback) {
      return;
    }

    model.currentFeedback$.set(feedback);
    const alertFeedback = this.createAlertFeedback(model.alertData$()!, feedback);
    this.alertFeedbackRepository.saveAlertFeedback(alertFeedback).subscribe((result: any) => {
      console.log(`Recorded user alert feedback successfully`);
    }, error => {
      console.log(`Recording user alert feedback failed`);
    });
  }

  protected createAlertFeedback(alertData: AlertData, feedback: 'POSITIVE'|'NEGATIVE'): AlertFeedback {
    const alertFeedback = new AlertFeedback();
    alertFeedback.feedback = feedback;

    if(alertData.alertInstanceId) {
      alertFeedback.alertInstanceId = Number(alertData.alertInstanceId);
    }

    if(alertData.status !== null && alertData.status !== undefined) {
      if(!isNaN(alertData.status.valueOf())) {
        if(alertData.status === AlertStatus.OPEN) {
          alertFeedback.alertStatus = 'OPEN';
        }
        else if(alertData.status === AlertStatus.ACKNOWLEDGED) {
          alertFeedback.alertStatus = 'ACKNOWLEDGED';
        }
        else if(alertData.status === AlertStatus.CLOSED) {
          alertFeedback.alertStatus = 'CLOSED';
        }
      }
      else {
        alertFeedback.alertStatus = alertData.status.toString()
      }

    }

    alertFeedback.alertRuleId = alertData.alertRuleId!;
    alertFeedback.alertOpenedDate = alertData.openDatetimeMillis!;
    alertFeedback.alertClosedDate = alertData.closeDatetimeMillis!;
    alertFeedback.alertAckDate = alertData.ackDatetimeMillis!
    alertFeedback.alertType = alertData.alertRuleType!;
    alertFeedback.alertClient = alertData.client!;
    alertFeedback.alertPlant = alertData.plant!;
    alertFeedback.alertLine = alertData.line!;
    alertFeedback.alertAssetName = alertData.asset!;
    alertFeedback.userEmail = this.userSession.email!;
    alertFeedback.userType = this.userSession.userType!;

    return alertFeedback;
  }
}
